<div class="footer-container" [ngClass]="{ 'qd': brokerId === '04' }">
  <div class="footer-box">
    @if (brokerId === '01') {
    <div class="footer-logos">
      <img src="assets/images/footer-logo.svg" alt="Chill Insurance Logo" width="100px" />
    </div>

    <mat-divider class="divider"></mat-divider>
    }

    <div class="copyright">
      @if (brokerId === '01') {
      <div>
        Copyright © Chill Insurance. All Rights Reserved. Chill Insurance Ltd.
        Chill Insurance is regulated by the Central Bank of Ireland. Registered
        number 506021. Registered in the Republic of Ireland.<a id="terms-of-business"
          href="{{ chillPortalAddress }}company/legal/terms-of-business/" target="_blank">
          Terms of Business,</a>

        <a id="privacy-policy" href="{{ chillPortalAddress }}company/legal/privacy-policy/" target="_blank">Privacy
          Policy.</a>
      </div>

      <!-- OneTrust Cookies Settings button start -->
      <button id="ot-sdk-btn" class="ot-sdk-show-settings">
        Cookie Settings
      </button>
      <!-- OneTrust Cookies Settings button end -->
      } @else if (brokerId === '04') {
      <div class="copyright-qd">
        Copyright @ Quote Devil Insurance. All Rights Reserved. Quote Devil Insurance Ltd. t/a Quote Devil Insurance is
        regulated by the Central Bank of Ireland. Registered number 430291. Registered in the Republic of Ireland. Terms
        of Business. Privacy Policy.
      </div>

      <!-- OneTrust Cookies Settings button start -->
      <button id="ot-sdk-btn" class="ot-sdk-show-settings">
        Cookie Settings
      </button>
      <!-- OneTrust Cookies Settings button end -->
      }
    </div>
  </div>
</div>